import D2C_ServiceOther from './Other'

class D2C_ServiceDocker extends D2C_ServiceOther {
  static objectType = 'serviceType'
  static active = true
  static order = 40
  static typeName = 'docker'
  static typeTitle = 'Docker'
  static color = '#2299ee'
  static methods = {
    ...D2C_ServiceOther.methods,
    scale: true,
  }
  static fields = {
    ...D2C_ServiceOther.fields,
    capabilities: {
      default: [],
      detailed: true,
      enum: [
        {value: 'AUDIT_CONTROL', text: 'AUDIT_CONTROL', description: 'Enable and disable kernel auditing; change auditing filter rules; retrieve auditing status and filtering rules'},
        {value: 'BLOCK_SUSPEND', text: 'BLOCK_SUSPEND', description: 'Employ features that can block system suspend'},
        {value: 'DAC_READ_SEARCH', text: 'DAC_READ_SEARCH', description: 'Bypass file read permission checks and directory read and execute permission checks'},
        {value: 'IPC_LOCK', text: 'IPC_LOCK', description: 'Lock memory (mlock(2), mlockall(2), mmap(2), shmctl(2))'},
        {value: 'IPC_OWNER', text: 'IPC_OWNER', description: 'Bypass permission checks for operations on System V IPC objects'},
        {value: 'LEASE', text: 'LEASE', description: 'Establish leases on arbitrary files (see fcntl(2))'},
        {value: 'LINUX_IMMUTABLE', text: 'LINUX_IMMUTABLE', description: 'Set the FS_APPEND_FL and FS_IMMUTABLE_FL i-node flags'},
        {value: 'MAC_ADMIN', text: 'MAC_ADMIN', description: 'Allow MAC configuration or state changes. Implemented for the Smack LSM'},
        {value: 'MAC_OVERRIDE', text: 'MAC_OVERRIDE', description: 'Override Mandatory Access Control (MAC). Implemented for the Smack Linux Security Module (LSM)'},
        {value: 'NET_ADMIN', text: 'NET_ADMIN', description: 'Perform various network-related operations'},
        {value: 'NET_BROADCAST', text: 'NET_BROADCAST', description: 'Make socket broadcasts, and listen to multicasts'},
        {value: 'SYS_ADMIN', text: 'SYS_ADMIN', description: 'Perform a range of system administration operations'},
        {value: 'SYS_BOOT', text: 'SYS_BOOT', description: 'Use reboot(2) and kexec_load(2), reboot and load a new kernel for later execution'},
        {value: 'SYS_MODULE', text: 'SYS_MODULE', description: 'Load and unload kernel modules'},
        {value: 'SYS_NICE', text: 'SYS_NICE', description: 'Raise process nice value (nice(2), setpriority(2)) and change the nice value for arbitrary processes'},
        {value: 'SYS_PACCT', text: 'SYS_PACCT', description: 'Use acct(2), switch process accounting on or off'},
        {value: 'SYS_PTRACE', text: 'SYS_PTRACE', description: 'Trace arbitrary processes using ptrace(2)'},
        {value: 'SYS_RAWIO', text: 'SYS_RAWIO', description: 'Perform I/O port operations (iopl(2) and ioperm(2))'},
        {value: 'SYS_RESOURCE', text: 'SYS_RESOURCE', description: 'Override resource Limits'},
        {value: 'SYS_TIME', text: 'SYS_TIME', description: 'Set system clock (settimeofday(2), stime(2), adjtimex(2)); set real-time (hardware) clock'},
        {value: 'SYS_TTY_CONFIG', text: 'SYS_TTY_CONFIG', description: 'Use vhangup(2); employ various privileged ioctl(2) operations on virtual terminals'},
        {value: 'SYSLOG', text: 'SYSLOG', description: 'Perform privileged syslog(2) operations'},
        {value: 'WAKE_ALAR', text: 'WAKE_ALAR', description: 'Trigger something that will wake up the system'},
      ],
      label: 'Extra capabilities',
      multiple: true,
      path: 'capabilities',
      required: false,
      validate() {
        return null
      },
      creating: {},
      updating: {},
      importing: {},
    },
    deployCommands: {
      default: '',
      label: 'Local dependencies and code\'s preparation',
      path: 'deployCommands',
      syntaxis: 'shell',
      validate() {
        return null
      },
      creating: {},
      updating: {},
      importing: {},
    },
    devices: {
      allowAdditions: true,
      default: [],
      enum: [],
      examples: ['/dev/net/tun'],
      label: 'Devices',
      multiple: true,
      path: 'devices',
      placeholder: 'Type and press Enter...',
      required: false,
      validate(value) {
        const errors = []
        value.forEach(device => {
          if (device.substr(0, 5) !== '/dev/') {
            errors.push(device)
          }
        })
        if (errors.length) {
          return `Invalid devices name: ${errors.join(', ')} (must be started with /dev/)`
        }
        return null
      },
      creating: {},
      updating: {},
      importing: {
        hidden: true,
      },
    },
    hosts: {
      ...D2C_ServiceOther.fields.hosts,
      selector: {
        default: ['node', 'node'],
      },
    },
    image: {
      ...D2C_ServiceOther.fields.image,
      default: '',
      official: ['adminer', 'adoptopenjdk', 'aerospike', 'alpine', 'alt', 'amazoncorretto', 'amazonlinux', 'arangodb', 'archlinux', 'backdrop', 'bash', 'bonita', 'buildpack-deps', 'busybox', 'caddy', 'cassandra', 'celery', 'centos', 'chronograf', 'cirros', 'clearlinux', 'clefos', 'clojure', 'composer', 'consul', 'convertigo', 'couchbase', 'couchdb', 'crate', 'crux', 'debian', 'django', 'docker', 'drupal', 'eclipse-mosquitto', 'eggdrop', 'elasticsearch', 'elixir', 'erlang', 'euleros', 'express-gateway', 'fedora', 'flink', 'fluentd', 'friendica', 'fsharp', 'gazebo', 'gcc', 'geonetwork', 'ghost', 'glassfish', 'golang', 'gradle', 'groovy', 'haproxy', 'haskell', 'haxe', 'hello-seattle', 'hello-world', 'hipache', 'hola-mundo', 'httpd', 'hylang', 'ibmjava', 'influxdb', 'iojs', 'irssi', 'java', 'jenkins', 'jetty', 'jobber', 'joomla', 'jruby', 'julia', 'kaazing-gateway', 'kapacitor', 'kibana', 'known', 'kong', 'lightstreamer', 'logstash', 'mageia', 'mariadb', 'matomo', 'maven', 'mediawiki', 'memcached', 'mongo-express', 'mongo', 'mono', 'mysql', 'nats-streaming', 'nats', 'neo4j', 'neurodebian', 'nextcloud', 'nginx', 'node', 'notary', 'nuxeo', 'odoo', 'open-liberty', 'openjdk', 'opensuse', 'oraclelinux', 'orientdb', 'owncloud', 'percona', 'perl', 'photon', 'php-zendserver', 'php', 'piwik', 'plone', 'postfixadmin', 'postgres', 'pypy', 'python', 'r-base', 'rabbitmq', 'rails', 'rakudo-star', 'rapidoid', 'redis', 'redmine', 'registry', 'rethinkdb', 'rocket.chat', 'ros', 'ruby', 'rust', 'sapmachine', 'sentry', 'silverpeas', 'sl', 'solr', 'sonarqube', 'sourcemage', 'spiped', 'storm', 'swarm', 'swift', 'swipl', 'teamspeak', 'telegraf', 'thrift', 'tomcat', 'tomee', 'traefik', 'ubuntu', 'varnish', 'vault', 'websphere-liberty', 'wordpress', 'xwiki', 'yourls', 'znc', 'zookeeper'],
      examples: ['openjdk', 'million12/varnish', 'quay.io/letsencrypt/dnsmasq'],
      omit: false,
      readonly: false,
      required: true,
      creating: {
        ...D2C_ServiceOther.fields.image.creating,
        autoselect: true,
      },
      importing: {
        readonly: true,
      },
    },
    interface: {
      default: '',
      examples: ['all', 'default_ipv4', 'lo', 'docker0', 'eth0'],
      label: 'Listen interface',
      path: 'interface',
      placeholder: 'All interfaces by default',
      required: false,
      width: 10,
      validate(value) {
        if (value && !/^[a-z][a-z0-9_]{1,15}$/.test(value)) {
          return 'should start with a letter and contain 2-16 letters, digits or underscore'
        }
        return null
      },
      creating: {},
      updating: {},
      importing: {
        hidden: true,
      },
    },
    labels: {
      default: [],
      label: 'Container metadata (labels)',
      path: 'labels',
      required: false,
      validate() {
        return null
      },
      creating: {},
      updating: {},
      importing: {
        hidden: true,
      },
    },
    name: {
      ...D2C_ServiceOther.fields.name,
      creating: {
        ...D2C_ServiceOther.fields.name.creating,
        autoselect: false,
      },
    },
    network: {
      default: 'weave',
      enum: [
        {value: 'weave', text: 'weave'},
        {value: 'host', text: 'host'},
      ],
      label: 'Network',
      path: 'network',
      required: false,
      width: 6,
      validate() {
        return null
      },
      creating: {},
      updating: {},
      importing: {
        hidden: true,
      },
    },
    ports: {
      ...D2C_ServiceOther.fields.ports,
      default: [
        {protocol: 'TCP', value: 3000},
      ],
    },
    securityOpts: {
      allowAdditions: true,
      default: [],
      enum: [],
      label: 'Security options',
      multiple: true,
      path: 'securityOpts',
      placeholder: 'Type and press Enter...',
      required: false,
      validate() {
        return null
      },
      creating: {},
      updating: {},
      importing: {
        hidden: true,
      },
    },
    source: {
      default: {
        type: 'download',
        url: '',
      },
      label: 'Source',
      path: 'source',
      placeholder: 'https://',
      required: false,
      validate() {
        return null
      },
      creating: {},
      updating: {},
      updatingSource: {},
      importing: {},
    },
    startCommand: {
      default: '',
      label: 'Command to start',
      path: 'startCommand',
      syntaxis: 'shell',
      validate() {
        return null
      },
      creating: {},
      importing: {},
      updating: {},
    },
    sysctls: {
      default: [],
      label: 'Kernel parameters (sysctls)',
      path: 'sysctls',
      required: false,
      tooltip: `Currently supported sysctls:
- kernel.msgmax, kernel.msgmnb, kernel.msgmni, kernel.sem, kernel.shmall, kernel.shmmax, kernel.shmmni, kernel.shm_rmid_forced
- sysctls beginning with fs.mqueue.*
- sysctls beginning with net.*`,
      validate() {
        return null
      },
      creating: {},
      updating: {},
      importing: {
        hidden: true,
      },
    },
    version: {
      ...D2C_ServiceOther.fields.version,
      default: 'latest',
      enum: null,
      importing: {
        readonly: true,
      },
    },
    volumes: {
      ...D2C_ServiceOther.fields.volumes,
      uid: true,
      demo: [
        {src: '/ebs/containers/$serviceName/sources', dst: '/var/www/$serviceName', sync: false, uid: 0},
      ],
    },
    volumesUID: {
      default: 0,
      label: 'Default UID',
      path: 'volumesUID',
      validate(value) {
        if (value < 0 || value > 65534) {
          return 'UID must be between 0 and 65534'
        }
        return null
      },
      creating: {},
      updating: {},
      importing: {
        hidden: true,
      },
    },
  }
  get _typeTitle() {
    const parts = this.image.split('/')
    return parts[parts.length - 1]
  }
  get _isOfficialImage() {
    return this.constructor.fields.image.official.includes(this.image)
  }
}

export default D2C_ServiceDocker
